var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeagueOfLegends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0966 5.32999C14.2811 5.52052 15.3936 6.02263 16.3201 6.78484C17.2466 7.54705 17.9538 8.54194 18.3691 9.66751C18.7844 10.7931 18.8929 12.0089 18.6835 13.1902C18.474 14.3715 17.9542 15.4759 17.1773 16.3901H19.4615C20.243 15.0639 20.6541 13.5522 20.6518 12.0129C20.6518 7.609 17.3562 3.975 13.0966 3.44226V5.32999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50532 18.666V15.9483C5.68371 14.8005 5.24193 13.4243 5.24193 12.0128C5.24193 10.6013 5.68371 9.22514 6.50532 8.07736V5.35876C5.52642 6.16925 4.73842 7.18577 4.19754 8.3358C3.65666 9.48584 3.37622 10.7411 3.37622 12.0119C3.37622 13.2828 3.65666 14.538 4.19754 15.6881C4.73842 16.8381 5.52642 17.8546 6.50532 18.6651V18.666Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8028 2.65625H6.85315L7.79902 4.59113V19.427L6.86292 21.3406H18.0803L19.1053 17.6839H11.8028V2.65625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeagueOfLegends);
export default __webpack_public_path__ + "static/media/league_of_legends.26a5f054746353480c78ebc0bdc80db6.svg";
export { ForwardRef as ReactComponent };